export class Parameter {

}
